import axios from 'axios';
import { Auth } from 'aws-amplify';
import * as qs from 'qs';

const UNAUTHORIZED = 401;

const client = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
    },
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  };

  // Create instance
  const instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use((config) => {
    return Auth.currentSession()
      .then((userSession) => {
        const idToken = userSession.getIdToken().getJwtToken();
        config.headers.Authorization = `Bearer ${ idToken }`;
        return config;
      })
      .catch((_err) => {
        config.headers.Authorization = 'Bearer ThisIsNotAToken';
        return config;
      });
  });

  // Add a response interceptor
  instance.interceptors.response.use((response) => {
    // Do something with response data
    return response.data;
  }, (err) => {
    // Do something with response error
    if (err.response && err.response.status === UNAUTHORIZED) {
      return Auth.signOut().finally(() => {
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, '', '/');
      });
    }
    return Promise.reject(err);
  });

  return instance;
};

export default client();
